export interface PermissionCategory {
	label: string;
	permissions: string[];
}

export const PERMISSION_CATEGORIES: PermissionCategory[] = [
	{
		label: "Social Feed",
		permissions: [
			"CanViewSocialPosts",
			"CanSubmitSocialPosts",
			"CanEditOthersSocialPosts",
			"CanModerateReportedSocialPosts",
			"CanScheduleSocialPosts"
		]
	},
	{
		label: "Observations",
		permissions: [
			"CanSubmitObservations",
			"CanViewEditObservationForms",
			"CanViewObservationReporting"
		]
	},
	{
		label: "Content Admin",
		permissions: [
			"CanManageAnnouncements",
			"CanViewEditEvents",
			"CanViewEditHomepageContent",
			"CanViewEditNavigation"
		]
	},
	{
		label: "Analytics",
		permissions: ["CanViewAnalytics", "CanViewUserAnalytics"]
	},
	{
		label: "People & Groups",
		permissions: [
			"CanViewEditPeople",
			"CanViewEditLocations",
			"CanViewEditGroups",
			"CanViewEditUserRoles"
		]
	},
	{
		label: "Media",
		permissions: ["CanUploadMedia", "CanManageMedia"]
	},
	{
		label: "News",
		permissions: ["CanViewNews", "CanManageNews"]
	},
	{
		label: "Notifications",
		permissions: ["CanManageNotifications"]
	},
	{
		label: "Other",
		permissions: ["CanManageHashtags", "CanManageSettings"]
	},
	{
		label: "System",
		permissions: ["CanImpersonate"]
	}
];

export const SEEDED_ROLE_NAMES = [
	"AppUser",
	"ObservationAdmin",
	"ContentAdmin",
	"SuperAdmin"
] as const;

export function isSeededRole(name: string): boolean {
	return (SEEDED_ROLE_NAMES as readonly string[]).includes(name);
}

export function formatPermissionName(permission: string): string {
	return permission
		.replace(/^Can/, "")
		.replace(/([A-Z])/g, " $1")
		.trim();
}
